import { useMemo } from "react";
import { useQuery } from "urql";
import { DepartmentListQry } from "api/queries/user";
import { useUserDepartment, useUserActions } from "stores/user";
import { useIsSameProj } from "stores/globalStore";

export const useUserDepartments = () => {
  const isSameProj = useIsSameProj();
  const userActions = useUserActions();
  const selectedDepartment = useUserDepartment();

  const [{ data: departmentsData, error, fetching, stale }] = useQuery({
    query: DepartmentListQry,
    variables: {
      input: {
        onlyMyDepartments: true,
        page: 1,
        size: 1000,
      },
    },
    requestPolicy: "cache-first",
    pause: !isSameProj,
  });

  const isLoading = fetching || stale;

  const departmentsOptions = useMemo(() => {
    if (departmentsData?.departments?.items && !isLoading) {
      const {
        departments: { items: departments },
      } = departmentsData;
      const options = departments.map((dept) => ({
        value: dept?.id,
        label: dept?.name,
      }));
      let matchExists = false;
      if (selectedDepartment?.value) {
        options.forEach((opt) => {
          if (opt.value === selectedDepartment.value) {
            matchExists = true;
          }
        });
      }
      if ((!selectedDepartment || !matchExists) && options.length > 0) {
        userActions.setDepartment(options[0]);
      }
      if (options.length === 0) {
        userActions.setDepartment(null);
      }
      return options;
    }
    return null;
  }, [selectedDepartment, departmentsData, isLoading, userActions]);

  return {
    options: departmentsOptions || [],
    selected: selectedDepartment || null,
    setSelected: userActions.setDepartment,
    error: error || null,
  };
};
